<template>
  <div class="container">
    <b-field horizontal :label="$translate('id_shoe') | capitalize">
      <b-input name="id_shoe" v-model="mod.id" disabled></b-input>
    </b-field>

    <b-field
      :type="{ 'is-danger': errors.has('name') }"
      :message="errors.first('name')"
      horizontal
      :label="$translate('name') | capitalize"
    >
      <b-input name="name" v-model="mod.name" v-validate="'required|unique'"></b-input>
    </b-field>

    <b-field
      :type="{ 'is-danger': errors.has('position') }"
      :message="errors.first('position')"
      horizontal
      :label="$translate('model_position') | capitalize"
    >
      <b-input
        name="position"
        v-model="mod.position"
        v-validate="'numeric|min_value:1'"
        type="number"
        step="1"
        :use-html5-validation="false"
      ></b-input>
    </b-field>

    <b-field
      v-if="$moduleConfiguration[module].modelHasGender"
      :type="{ 'is-danger': errors.has('catalogType') }"
      :message="errors.first('catalogType')"
      horizontal
      :label="$translate('catalogType') | capitalize"
    >
      <b-select name="catalogType" v-model="mod.catalogType" v-validate="'required'">
        <option v-for="optio in $availableSexType" :key="optio" :value="optio">
          {{ $translate(optio) | capitalize }}
        </option>
      </b-select>
    </b-field>
    <b-field
      v-if="$moduleConfiguration[module].modelHasLowHigh"
      :type="{ 'is-danger': errors.has('shoeType') }"
      :message="errors.first('shoeType')"
      horizontal
      :label="$translate('shoeType') | capitalize"
    >
      <b-select name="shoeType" v-model="mod.shoeType" v-validate="'required'">
        <option v-for="optio in $availableShoeType" :key="optio" :value="optio">{{
          $translate(optio) | capitalize
        }}</option>
      </b-select>
    </b-field>
    <b-field
      v-if="$moduleConfiguration[module].modelHasSeason"
      :type="{ 'is-danger': errors.has('seasontags') }"
      :message="errors.first('seasontags')"
      :label="$translate('seasontags') | capitalize"
      horizontal
    >
      <b-select name="seasontags" v-model="mod.seasontags" :placeholder="$translate('placeholder_select')">
        <option v-for="item in $seasontag" :key="item" :value="item">{{ $translate(item) | capitalize }}</option>
      </b-select>
    </b-field>

    <b-field
      v-if="$moduleConfiguration[module].modelHasShapes"
      horizontal
      :label="$translate('available_shapes') | capitalize"
      :message="errors.first('available_shapes')"
      :type="{ 'is-danger': errors.has('available_shapes') }"
    >
      <b-select
        v-model="mod.shapes"
        class="select-is-large"
        v-validate="'required'"
        data-vv-validate-on="blur"
        name="available_shapes"
        multiple
      >
        <option v-for="shape in filteredShapes" :key="shape.id" :value="shape.id">
          {{ shape.commercial_name + ' ' + shape.fit_code }}
        </option>
      </b-select>
    </b-field>

    <b-field
      v-if="$moduleConfiguration[module].hasSecondaryPrev"
      horizontal
      :label="$translate('secondary_prevention') | capitalize"
      :message="errors.first('secondary_prevention')"
      :type="{ 'is-danger': errors.has('secondary_prevention') }"
    >
      <b-switch v-model="mod.hasSecondaryPrev" />
    </b-field>

    <b-field
      v-if="$moduleConfiguration[module].hasRestrictedAllestimentoTomaia"
      horizontal
      :label="$translate('unique_composition') | capitalize"
      :message="errors.first('unique_composition')"
      :type="{ 'is-danger': errors.has('unique_composition') }"
    >
      <b-switch v-model="mod.uniqueComposition" />
    </b-field>
    <b-field
      v-if="$moduleConfiguration[module].modelHasDime"
      :type="{ 'is-danger': errors.has('dime') }"
      :message="errors.first('dime')"
      horizontal
      :label="$translate('dime') | capitalize"
    >
      <b-field grouped>
        <b-select name="dime" v-model="mod.dime" v-validate="'required'" @input="onDimeChange">
          <option v-for="optio in $availableDime" :key="optio" :value="optio">
            {{ $translate(optio) | capitalize }}
          </option>
        </b-select>
        <b-input
          :placeholder="$translate('placeholder_description')"
          v-if="mod.dime === 'dunadime'"
          v-model="mod.dime_description"
          :v-validate="mod.dime && 'required'"
          :controls="false"
          expanded
        ></b-input>
      </b-field>
    </b-field>

    <b-field
      v-if="$moduleConfiguration[module].modelHasDime && (mod.dime === 'dunadime' || mod.dime === 'customerdime')"
      :type="{ 'is-danger': errors.has('dime_fondo') }"
      :message="errors.first('dime_fondo')"
      horizontal
      :label="$translate('fondo') | capitalize"
    >
      <b-select name="dime_fondo" v-model="mod.dime_fondo" v-validate="'required'" @input="onDimeFondoChange">
        <option value="flat_plantar">{{ $translate('flat_plantar') | capitalize }}</option>
        <option value="shaped_plantar">{{ $translate('shaped_plantar') | capitalize }}</option>
      </b-select>
    </b-field>

    <b-field
      v-if="
        $moduleConfiguration[module].modelHasDime &&
          (mod.dime === 'dunadime' || mod.dime === 'customerdime') &&
          mod.dime_fondo === 'shaped_plantar'
      "
      :type="{ 'is-danger': errors.has('cambratura_fondo') }"
      :message="errors.first('cambratura_fondo')"
      horizontal
      :label="$translate('cambratura_fondo') | capitalize"
    >
      <b-input
        name="cambratura_fondo"
        v-model="mod.cambratura_fondo"
        v-validate="'required|between:0,999'"
        type="number"
        :placeholder="$translate('placeholder_measure_mm')"
        :use-html5-validation="false"
      />
    </b-field>

    <b-field
      v-if="$moduleConfiguration[module].modelHasCustomSizes"
      class="is-narrow"
      horizontal
      :label="$translate('custom_sizes') | capitalize"
    >
      <b-switch v-model="customSizeRange" />
      <b-numberinput
        :placeholder="$translate('custom_input_min')"
        v-if="customSizeRange"
        v-model="mod.sizes.min"
        :v-validate="'required'"
        :controls="false"
      ></b-numberinput>
      <b-numberinput
        :placeholder="$translate('custom_input_max')"
        v-if="customSizeRange"
        v-model="mod.sizes.max"
        :v-validate="'required'"
        :controls="false"
      ></b-numberinput>
    </b-field>

    <b-field
      class="file"
      :type="{ 'is-danger': errors.has('catalog_image') }"
      :label="$translate('catalog_image') | capitalize"
      :message="errors.first('catalog_image')"
      horizontal
    >
      <template v-if="mod.imagepresent">
        <table>
          <tr>
            <img v-bind:src="mod.image" width="100" height="100" />
          </tr>
          <tr>
            <b-button type="is-danger" icon-left="delete-outline" @click="removeImage()"
              >{{ $translate('catalog_remove_image') | capitalize }}
            </b-button>
          </tr>
        </table>
      </template>

      <b-upload v-model="mod.image" name="catalog_image" v-validate="'required'" v-else>
        <a class="button is-primary">
          <b-icon icon="upload"></b-icon>
          <span>{{ $translate('upload_button') | capitalize }}</span>
        </a>
        <span class="file-name" v-if="mod.image">
          {{ mod.image.name }}
        </span>
      </b-upload>
    </b-field>

    <b-field
      class="file"
      :type="{ 'is-danger': errors.has('render_image') }"
      :label="$translate('render_image') | capitalize"
      :message="errors.first('render_image')"
      horizontal
    >
      <template v-if="mod.renderpresent">
        <table>
          <tr>
            <a target="_blank" v-bind:href="mod.render">
              <b-icon icon="file"></b-icon>
            </a>
          </tr>
          <tr>
            <b-button type="is-danger" icon-left="delete-outline" @click="removeRender()"
              >{{ $translate('catalog_render_image') | capitalize }}
            </b-button>
          </tr>
        </table>
      </template>

      <b-upload v-model="mod.render" name="render_image" v-else>
        <a class="button is-primary">
          <b-icon icon="upload"></b-icon>
          <span>{{ $translate('upload_button') | capitalize }}</span>
        </a>
        <span class="file-name" v-if="mod.render">
          {{ mod.render.name }}
        </span>
      </b-upload>
    </b-field>
    <b-field
      v-if="$moduleConfiguration[module].modelHasDescription"
      :label="$translate('description') | capitalize"
      horizontal
    >
      <b-input name="description" type="textarea" v-model="mod.description"></b-input>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'GeneralInfoModel',
  props: ['mod', 'module'],
  inject: ['$validator'],
  data() {
    return {
      shapes: [],
    }
  },
  computed: {
    customSizeRange: {
      get() {
        return !!(this.mod && this.mod.sizes)
      },
      set(val) {
        if (!this.mod) return
        if (val) {
          const existing = this.mod.sizes ? this.mod.sizes : {}
          this.mod.sizes = { min: existing.min ? existing.min : null, max: existing.max ? existing.max : null }
        } else {
          this.mod.sizes = null
        }
      },
    },
    filteredShapes() {
      return this.shapes.filter(shape => shape.catalogType.includes(this.mod.catalogType))
    },
  },
  async mounted() {
    if (this.$moduleConfiguration[this.module].modelHasShapes) {
      this.$db
        .collection(this.$moduleConfiguration[this.module].shapes)
        .get()
        .then(shapes => {
          const availableShapes = []
          shapes.forEach(doc => {
            let shape = doc.data()
            shape.id = doc.id
            availableShapes.push(shape)
          })
          this.shapes = [...availableShapes]
        })
    }
  },
  methods: {
    onDimeChange() {
      if (this.mod.dime !== 'dunadime') {
        this.$set(this.mod, 'dime_description', null)
      }
      if (this.mod.dime !== 'dunadime' && this.mod.dime !== 'customerdime') {
        this.$set(this.mod, 'dime_fondo', null)
        this.$set(this.mod, 'cambratura_fondo', null)
      }
    },
    onDimeFondoChange() {
      if (this.mod.dime_fondo !== 'shaped_plantar') {
        this.$set(this.mod, 'cambratura_fondo', null)
      }
    },
    removeImage() {
      this.mod.imagetoremove = true
      this.mod.imagepresent = false
      this.mod.image = null
    },
    removeRender() {
      this.mod.rendertoremove = true
      this.mod.renderpresent = false
      this.mod.render = null
    },
  },
}
</script>
<style scoped>
.select-is-large >>> select {
  min-width: 300px;
  min-height: 300px;
  overflow-x: auto;
}
</style>
